import clsx from "clsx";
import { useId } from "react";

import { FormControl } from "./FormControl";

export const Select: React.FC<
  Pick<React.ComponentProps<typeof FormControl>, "label" | "hint" | "error"> &
    React.ComponentProps<"select">
> = ({ label, hint, error, className, ...props }) => {
  const id = useId();
  return (
    <FormControl id={id} label={label} hint={hint} error={error}>
      <select
        id={id}
        className={clsx(
          "select select-bordered group-aria-[invalid=true]/form-control:input-error",
          className,
        )}
        {...props}
      />
    </FormControl>
  );
};
